/**
 * PDI Loyalty International API v1.5.20
 * Note: All dates/times returned via API call will be UTC / Accept-Encoding: gzip, deflate<br><br><a href='https://pditechnologies.com/engage-customers/loyalty-marketing-solutions/'>PDI Technologies website</a><br><a href='mailto:azpiral-info@pditechnologies.com?subject=AzpiralAPI'>Send an email to PDI Technologies</a><br><a href='../../Contents/FlowDiagrams/Index.htm'>Flow Diagrams</a><br><a href='../../v1/Helpers/ApiErrors/'>Error Codes</a>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CartLine model module.
 * @module model/CartLine
 * @version v1
 */
class CartLine {
    /**
     * Constructs a new <code>CartLine</code>.
     * @alias module:model/CartLine
     * @param lineNumber {Number} 
     * @param productCode {String} MaxLength:20
     * @param productDesc {String} MaxLength:50
     * @param quantity {Number} 
     * @param totalValue {Number} 
     */
    constructor(lineNumber, productCode, productDesc, quantity, totalValue) { 
        
        CartLine.initialize(this, lineNumber, productCode, productDesc, quantity, totalValue);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, lineNumber, productCode, productDesc, quantity, totalValue) { 
        obj['LineNumber'] = lineNumber;
        obj['ProductCode'] = productCode;
        obj['ProductDesc'] = productDesc;
        obj['Quantity'] = quantity;
        obj['TotalValue'] = totalValue;
    }

    /**
     * Constructs a <code>CartLine</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CartLine} obj Optional instance to populate.
     * @return {module:model/CartLine} The populated <code>CartLine</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CartLine();

            if (data.hasOwnProperty('LineNumber')) {
                obj['LineNumber'] = ApiClient.convertToType(data['LineNumber'], 'Number');
            }
            if (data.hasOwnProperty('ProductCode')) {
                obj['ProductCode'] = ApiClient.convertToType(data['ProductCode'], 'String');
            }
            if (data.hasOwnProperty('ProductDesc')) {
                obj['ProductDesc'] = ApiClient.convertToType(data['ProductDesc'], 'String');
            }
            if (data.hasOwnProperty('Department')) {
                obj['Department'] = ApiClient.convertToType(data['Department'], 'String');
            }
            if (data.hasOwnProperty('Category')) {
                obj['Category'] = ApiClient.convertToType(data['Category'], 'String');
            }
            if (data.hasOwnProperty('SubCategory')) {
                obj['SubCategory'] = ApiClient.convertToType(data['SubCategory'], 'String');
            }
            if (data.hasOwnProperty('Quantity')) {
                obj['Quantity'] = ApiClient.convertToType(data['Quantity'], 'Number');
            }
            if (data.hasOwnProperty('TotalValue')) {
                obj['TotalValue'] = ApiClient.convertToType(data['TotalValue'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CartLine</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CartLine</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of CartLine.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['ProductCode'] && !(typeof data['ProductCode'] === 'string' || data['ProductCode'] instanceof String)) {
            throw new Error("Expected the field `ProductCode` to be a primitive type in the JSON string but got " + data['ProductCode']);
        }
        // ensure the json data is a string
        if (data['ProductDesc'] && !(typeof data['ProductDesc'] === 'string' || data['ProductDesc'] instanceof String)) {
            throw new Error("Expected the field `ProductDesc` to be a primitive type in the JSON string but got " + data['ProductDesc']);
        }
        // ensure the json data is a string
        if (data['Department'] && !(typeof data['Department'] === 'string' || data['Department'] instanceof String)) {
            throw new Error("Expected the field `Department` to be a primitive type in the JSON string but got " + data['Department']);
        }
        // ensure the json data is a string
        if (data['Category'] && !(typeof data['Category'] === 'string' || data['Category'] instanceof String)) {
            throw new Error("Expected the field `Category` to be a primitive type in the JSON string but got " + data['Category']);
        }
        // ensure the json data is a string
        if (data['SubCategory'] && !(typeof data['SubCategory'] === 'string' || data['SubCategory'] instanceof String)) {
            throw new Error("Expected the field `SubCategory` to be a primitive type in the JSON string but got " + data['SubCategory']);
        }

        return true;
    }


}

CartLine.RequiredProperties = ["LineNumber", "ProductCode", "ProductDesc", "Quantity", "TotalValue"];

/**
 * @member {Number} LineNumber
 */
CartLine.prototype['LineNumber'] = undefined;

/**
 * MaxLength:20
 * @member {String} ProductCode
 */
CartLine.prototype['ProductCode'] = undefined;

/**
 * MaxLength:50
 * @member {String} ProductDesc
 */
CartLine.prototype['ProductDesc'] = undefined;

/**
 * MaxLength:10
 * @member {String} Department
 */
CartLine.prototype['Department'] = undefined;

/**
 * MaxLength:10
 * @member {String} Category
 */
CartLine.prototype['Category'] = undefined;

/**
 * MaxLength:10
 * @member {String} SubCategory
 */
CartLine.prototype['SubCategory'] = undefined;

/**
 * @member {Number} Quantity
 */
CartLine.prototype['Quantity'] = undefined;

/**
 * @member {Number} TotalValue
 */
CartLine.prototype['TotalValue'] = undefined;






export default CartLine;

